module.exports = __webpack_public_path__ + "img/xhs-guide.a02b7f20.png";